import { CheckCircleOutlined } from "@ant-design/icons"; // Using Ant Design icons
import { usePaymentMethod } from "./modules/usePaymentMethod";
import { paymentMethods } from "./const";

function PaymentMethodTemplate() {
  const { paymentMethod, handlePaymentSelection } = usePaymentMethod();

  return (
    <div className="payment-method-container">
      <h2>Select Payment Method</h2>
      <p>Current Payment Method: {paymentMethod}</p>{" "}
      {/* Display current method */}
      <div className="payment-options">
        {paymentMethods.map((method) => (
          <div
            key={method}
            className={`payment-option ${
              paymentMethod === method ? "selected" : ""
            }`}
            onClick={() => handlePaymentSelection(method)}
          >
            <span>{method.charAt(0).toUpperCase() + method.slice(1)}</span>
            {paymentMethod === method && (
              <CheckCircleOutlined style={{ color: "green" }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PaymentMethodTemplate;
